<h2 mat-dialog-title>{{ is_edit_mode ? 'Editar plantilla de examen' : 'Nueva plantilla de examen' }}</h2>

<mat-dialog-content [formGroup]="form">
  @if (loading_data()) {
    <p>Cargando...</p>
  } @else {
    <mat-form-field class="full-width">
      <mat-label>Nombre</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>Descripción (opcional)</mat-label>
      <textarea matInput formControlName="description" rows="2"></textarea>
    </mat-form-field>

    <div class="items-section">
      <h3>Preguntas del examen</h3>

      <div class="add-item-filters">
        <mat-form-field class="skill-filter">
          <mat-label>Filtrar por skill</mat-label>
          <mat-select [value]="selected_skill_id()" (selectionChange)="onSkillFilterChanged($event.value)">
            <mat-option [value]="null">Todas</mat-option>
            @for (skill of skills(); track skill.id) {
              <mat-option [value]="skill.id">{{ skill.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field class="question-search">
          <mat-label>Buscar pregunta</mat-label>
          <input matInput [formControl]="question_search_control" [matAutocomplete]="question_auto" placeholder="Escribe para buscar..." />
          <mat-autocomplete
            #question_auto="matAutocomplete"
            [displayWith]="displaySkillQuestion"
            (optionSelected)="onSkillQuestionSelected($event.option.value)"
          >
            @for (skill_question of available_skill_questions(); track skill_question.id) {
              <mat-option [value]="skill_question"> #{{ skill_question.id }} — {{ skill_question.body }} </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>

        <button mat-stroked-button type="button" [disabled]="selected_skill_question() === null" (click)="addItemFromSelector()">
          <mat-icon>add</mat-icon>
          Añadir
        </button>
      </div>

      @if (items_form_array.length === 0) {
        <p class="empty-hint">No hay preguntas en la plantilla.</p>
      }

      @for (item_control of items_form_array.controls; track $index; let item_index = $index) {
        <div class="item-row" [formGroup]="$any(item_control)">
          <span class="item-order">{{ item_index + 1 }}</span>
          <span class="item-label">
            {{ getSkillQuestionLabel($safeNavigationMigration(item_control.get('skill_question_id')?.value)) }}
          </span>
          <mat-form-field appearance="outline" class="small weight-field">
            <mat-label>Peso</mat-label>
            <input matInput type="number" formControlName="weight" min="1" step="1" />
          </mat-form-field>
          <div class="item-actions">
            <button mat-icon-button type="button" aria-label="Subir" [disabled]="item_index === 0" (click)="moveItemUp(item_index)">
              <mat-icon>arrow_upward</mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              aria-label="Bajar"
              [disabled]="item_index === items_form_array.length - 1"
              (click)="moveItemDown(item_index)"
            >
              <mat-icon>arrow_downward</mat-icon>
            </button>
            <button mat-icon-button type="button" color="warn" aria-label="Quitar" (click)="removeItem(item_index)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancelar</button>
  <button mat-flat-button color="accent" type="button" [disabled]="loading() || loading_data() || form.invalid" (click)="save()">
    Guardar
  </button>
</mat-dialog-actions>
